import httpService from "./httpService.js"

export const getAllInstallmentsService = () => {
    return httpService("/shop_admin/installments/", "get");
}

export const getInstallmentsOfAnOrderService = (orderCode) => {
    return httpService(`/shop_admin/order_installment/${orderCode}/`, "get");
}

export const getSingleInstallmentService = (orderCode, installmentId) => {
    return httpService(`/shop_admin/installment/${orderCode}/${installmentId}/`, "get");
}

export const addNewInstallmentService = (data) => {
    return httpService("/shop_admin/installments/", "post", data);
}

export const editInstallmentService = (orderCode, installmentId, data) => {
    return httpService(`/shop_admin/installment/${orderCode}/${installmentId}/`, "patch", data);
}

export const deleteInstallmentService = (orderCode, installmentId) => {
    return httpService(`/shop_admin/installment/${orderCode}/${installmentId}/`, "delete");
}